import React, { useState } from 'react';
import Home from './paginas/index';
import Autenticacao from './paginas/autenticacao/Autenticacao';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import { StylesProvider, createGenerateClassName } from '@material-ui/core/styles';
import { SttThemeProvider, SttTranslateHook } from '@stt-componentes/core-v2';
import { SttThemeProvider as SttThemeProviderMui9 } from '@stt-componentes/core-v3';
import Alerta from './componentes/alerta';
import AvisoAtualizacao from './componentes/avisoAtualizacao';

// ⚠️ JSS do Material-UI v4 (legacy)
const generateClassName = createGenerateClassName({
    disableGlobal: true,
    productionPrefix: 'jss',
    seed: 'v4', // ajuda a evitar colisão se houver SSR ou múltiplas instâncias
});

const App = () => {
    const [loaded, setLoaded] = useState(false);

    return (
        <>
            <Autenticacao onLoaded={setLoaded} />
            {loaded && (
                <>
                    <NotificationContainer />
                    <StylesProvider generateClassName={generateClassName} injectFirst>
                        <SttThemeProvider config={global.gConfig}>
                            <SttThemeProviderMui9 config={global.gConfig}>
                                <SttTranslateHook.I18nContextProvider modulo={'gestaoPacs'}>
                                    <Home />
                                    <Alerta />
                                    <AvisoAtualizacao />
                                </SttTranslateHook.I18nContextProvider>
                            </SttThemeProviderMui9>
                        </SttThemeProvider>
                    </StylesProvider>
                </>
            )}
        </>
    );
};

export default App;
